export const iconFontAwesomeShoppingAlipay = (
	<i className="fa-solid fa-alipay"></i>
);
